import values from 'lodash/values';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DOMUtils from '@spothero/utils/dom';
import TextButton from '@spothero/ui/text-button';
import amenityIcons from 'common/amenities/amenities';

export default class AmenitiesListDesktop extends Component {
    static propTypes = {
        rate: PropTypes.object,
        isMonthly: PropTypes.bool.isRequired,
        nonRateAmenities: PropTypes.arrayOf(PropTypes.object).isRequired,
        onShowRateDetailsClick: PropTypes.func.isRequired,
    };

    _onRateDetailsClick = evt => {
        evt.preventDefault();

        this.props.onShowRateDetailsClick(
            DOMUtils.attr(evt.currentTarget, 'data-section')
        );
    };

    _renderIcon(icon) {
        const Icon = amenityIcons[icon];

        return (
            <span className="AmenityIcon">
                <Icon />
            </span>
        );
    }

    _renderInOut() {
        const {rate, isMonthly} = this.props;

        if (rate && isMonthly) {
            const inOut = rate.in_out.allowed;
            const items = [];

            switch (inOut) {
                case 'yes':
                    items.push(
                        <li key={inOut}>
                            {this._renderIcon('in-out')}
                            <span
                                className="AmenitiesList-item-content"
                                data-test="amenity"
                            >
                                Unlimited In/Out
                            </span>
                        </li>
                    );
                    break;

                case 'yes_fee':
                    items.push(
                        <li key={inOut}>
                            {this._renderIcon('in-out')}
                            <span
                                className="AmenitiesList-item-content"
                                data-test="amenity"
                            >
                                Unlimited In/Out
                                <TextButton
                                    data-section="in-out"
                                    onClick={this._onRateDetailsClick}
                                >
                                    with Fee
                                </TextButton>
                            </span>
                        </li>
                    );
                    break;

                case 'yes_limited':
                    items.push(
                        <li key={inOut}>
                            {this._renderIcon('in-out')}
                            <span
                                className="AmenitiesList-item-content"
                                data-test="amenity"
                            >
                                <TextButton
                                    data-section="in-out"
                                    onClick={this._onRateDetailsClick}
                                >
                                    Limited
                                </TextButton>{' '}
                                In/Out
                            </span>
                        </li>
                    );
                    break;

                case 'yes_limited_fee':
                    items.push(
                        <li key={inOut}>
                            {this._renderIcon('in-out')}
                            <span className="AmenitiesList-item-content">
                                Limited In/Out
                                <TextButton
                                    data-section="in-out"
                                    onClick={this._onRateDetailsClick}
                                >
                                    with Fee
                                </TextButton>
                            </span>
                        </li>
                    );
                    break;
            }

            return items;
        } else {
            return null;
        }
    }

    _renderOtherAmenities() {
        const {rate, nonRateAmenities} = this.props;

        if (rate) {
            return values(rate.amenities).map((amenity, i) => {
                return (
                    <li key={i}>
                        {this._renderIcon(amenity.slug)}
                        <span
                            className="AmenitiesList-item-content"
                            data-test="amenity"
                        >
                            {amenity.name}
                        </span>
                    </li>
                );
            });
        } else {
            return nonRateAmenities.map((amenity, i) => {
                if (amenity.visible) {
                    return (
                        <li key={i}>
                            {this._renderIcon(amenity.slug)}
                            <span
                                className="AmenitiesList-item-content"
                                data-test="amenity"
                            >
                                {amenity.name}
                            </span>
                        </li>
                    );
                } else {
                    return null;
                }
            });
        }
    }

    render() {
        const items = values(this._renderInOut()).concat(
            values(this._renderOtherAmenities())
        );

        return (
            <div className="AmenitiesListContainer">
                <h4 className="subtitle">Amenities</h4>
                <ul className="AmenitiesList">{items}</ul>
            </div>
        );
    }
}
